document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".title-text-description-terminos-condiciones").forEach(function(element) {
      if (element.querySelector(".arrow-down-terminos-y-condiciones")) {
          element.parentNode.querySelector(".container-description-terminos-y-condiciones").style.display = "none";
      }
  });

  document.querySelectorAll(".title-text-description-terminos-condiciones").forEach(function(element) {
      element.addEventListener("click", function() {
          var container = this.parentNode.querySelector(".container-description-terminos-y-condiciones");
          var arrowDown = this.querySelector(".arrow-down-terminos-y-condiciones");
          var arrowUp = this.querySelector(".arrow-up-terminos-y-condiciones");

          if (container.style.display === "block") {
              container.style.display = "none";
              arrowDown.style.display = "block";
              arrowUp.style.display = "none";
          } else {
              container.style.display = "block";
              arrowDown.style.display = "none";
              arrowUp.style.display = "block";
          }
      });
  });
  // if (location.href.includes("#promociones")) {
  //     var promociones = document.getElementById("promociones");
  //     if (promociones) {
  //         promociones.parentNode.querySelector(".container-description-terminos-y-condiciones").style.display = "block";
  //         promociones.querySelector(".arrow-up-terminos-y-condiciones").style.display = "block";
  //         promociones.querySelector(".arrow-down-terminos-y-condiciones").style.display = "none";
  //     }
  // }
});

